import {Component, OnDestroy, OnInit} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {Subscription} from "rxjs";
import {ModalParams} from "../../model/modal-params";
import {ModalType} from "../../model/modal-type";
import {Melody} from "../../model/melody";
import {SubscriberMelody} from "../../model/subscriber-melody";
import {Contact} from "../../model/contact";
import {Group} from "../../model/group";

@Component({
  selector: 'app-modals-block',
  templateUrl: './modals-block.component.html',
  styleUrls: ['./modals-block.component.css']
})
export class ModalsBlockComponent implements OnInit, OnDestroy {
  modalOpened: boolean;

  loginOpened: boolean;
  logoutOpened: boolean;
  purchaseOpened: boolean;
  giftOpened: boolean;
  subscriberMelodySettingsOpened: boolean;
  subscriberMelodyDeleteOpened: boolean;
  activateSubscriptionOpened: boolean;
  deactivateSubscriptionOpened: boolean;
  subscriptionInfoOpened: boolean;
  contactInfoOpened: boolean;
  groupInfoOpened: boolean;
  editContactOpened: boolean;
  editGroupOpened: boolean;
  deleteContactOpened: boolean;
  deleteGroupOpened: boolean;
  ugcUploadedOpened: boolean;
  chooseSubscriptions: boolean;

  melody: Melody;
  subscriberMelody: SubscriberMelody;
  privetPlusSubscription: boolean;
  contact: Contact;
  group: Group;
  callback: () => void;

  subscription: Subscription;

  constructor(public readonly modalsService: ModalsService) {
    this.modalOpened = false;

    this.loginOpened = false;
    this.logoutOpened = false;
    this.purchaseOpened = false;
    this.giftOpened = false;
    this.subscriberMelodySettingsOpened = false;
    this.subscriberMelodyDeleteOpened = false;
    this.activateSubscriptionOpened = false;
    this.deactivateSubscriptionOpened = false;
    this.subscriptionInfoOpened = false;
    this.contactInfoOpened = false;
    this.groupInfoOpened = false;
    this.editContactOpened = false;
    this.editGroupOpened = false;
    this.deleteContactOpened = false;
    this.deleteGroupOpened = false;
    this.ugcUploadedOpened = false;
    this.chooseSubscriptions = false;

    this.melody = null;
    this.subscriberMelody = null;
    this.privetPlusSubscription = false;
    this.contact = null;
    this.group = null;
    this.callback = null;

    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.modalsService.getShowModalsObservable().subscribe(params => this.showModal(params))
    );
  }

  showModal(params: ModalParams): void {
    this.modalOpened = params.show;

    this.loginOpened = params.modalType == ModalType.LOGIN;
    this.logoutOpened = params.modalType == ModalType.LOGOUT;
    this.purchaseOpened = params.modalType == ModalType.PURCHASE;
    this.giftOpened = params.modalType == ModalType.GIFT;
    this.subscriberMelodySettingsOpened = params.modalType == ModalType.SUBSCRIBER_MELODY_SETTINGS;
    this.subscriberMelodyDeleteOpened = params.modalType == ModalType.SUBSCRIBER_MELODY_DELETE;
    this.activateSubscriptionOpened = params.modalType == ModalType.ACTIVATE_SUBSCRIPTION;
    this.deactivateSubscriptionOpened = params.modalType == ModalType.DEACTIVATE_SUBSCRIPTION;
    this.subscriptionInfoOpened = params.modalType == ModalType.SUBSCRIPTION_INFO;
    this.contactInfoOpened = params.modalType == ModalType.CONTACT_INFO;
    this.groupInfoOpened = params.modalType == ModalType.GROUP_INFO;
    this.editContactOpened = params.modalType == ModalType.EDIT_CONTACT;
    this.editGroupOpened = params.modalType == ModalType.EDIT_GROUP;
    this.deleteContactOpened = params.modalType == ModalType.DELETE_CONTACT;
    this.deleteGroupOpened = params.modalType == ModalType.DELETE_GROUP;
    this.ugcUploadedOpened = params.modalType == ModalType.UGC_UPLOADED;
    this.chooseSubscriptions = params.modalType == ModalType.CHOOSE_SUBSCRIPTIONS;

    this.melody = params.melody;
    this.subscriberMelody = params.subscriberMelody;
    this.privetPlusSubscription = params.privetPlusSubscription;
    this.contact = params.contact;
    this.group = params.group;
    this.callback = params.callback;
  }

  doCallback(): void {
    if (this.callback) {
      this.callback();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
